import { render, staticRenderFns } from "./AsyncButton.vue?vue&type=template&id=496b1276&"
import script from "./AsyncButton.vue?vue&type=script&lang=js&"
export * from "./AsyncButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports